
import { Component, Prop, Vue } from 'vue-property-decorator';
import { debounce } from '@/util/debounce';
import Utility from '@/components/Passenger/models/Utility';

export interface RideitChangeRequestFilterFormData {
  passengerSearch: string;
  utilities: number[];
  status: string;
}

@Component
export default class RideitChangeRequestFilterForm extends Vue {
  @Prop({ required: true }) private value: RideitChangeRequestFilterFormData;
  @Prop({ default: () => [] }) private utilityOptions: Utility[];

  debouncedPassengerSearch = debounce(this.updatePassengerSearch, 500);

  get passengerSearch() {
    return this.value.passengerSearch;
  }

  set passengerSearch(newValue: string) {
    this.debouncedPassengerSearch(newValue);
  }

  get utilities() {
    return this.value.utilities;
  }

  set utilities(newValue: number[]) {
    this.updateValue({ ...this.value, utilities: newValue });
  }

  get status() {
    return this.value.status;
  }

  set status(newValue: string) {
    this.updateValue({ ...this.value, status: newValue });
  }

  get statusOptions() {
    return [
      { text: this.$t('rideIt.changeRequests.status.pending', 'Odottaa'), value: 'pending' },
      { text: this.$t('rideIt.changeRequests.status.approved', 'Hyväksytty'), value: 'approved' },
      { text: this.$t('rideIt.changeRequests.status.rejected', 'Hylätty'), value: 'rejected' },
    ];
  }

  translatedUtilityTitle(utility: Utility) {
    return this.$i18n.translate('utility.title.' + utility.title, utility.title);
  }

  updatePassengerSearch(newValue: string) {
    this.updateValue({ ...this.value, passengerSearch: newValue });
  }

  updateValue(newValue: RideitChangeRequestFilterFormData) {
    this.$emit('input', newValue);
  }
}
